import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { BodyBackgroundService } from '../../services/body-background.service';

@Component({
  selector: 'lib-design-system-reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss']
})
export class DesignSystemResetPasswordEmailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() backgroundColor?: string;
  @Input() logoType: 'white' | 'color' = 'color';
  @Input() resetIdExists: boolean = false;
  @Input() isLoading$: Observable<boolean> = of(false);
  @Input() error$: Observable<string | null> = of(null);
  @Input() resetPasswordSuccess$: Observable<boolean> = of(false);

  @Output() submitEmail = new EventEmitter<string>();
  @Output() errorDismiss = new EventEmitter<void>();
  @Output() successDismiss = new EventEmitter<void>();

  formResetEmail!: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private bodyBackgroundService: BodyBackgroundService
  ) {}

  ngOnInit(): void {
    this.formResetEmail = this.formBuilder.group({
      username: [
        '',
        [
          Validators.required,
          Validators.email,
        ],
      ],
    });

    // Apply background to body if backgroundColor is provided
    this.bodyBackgroundService.applyBackground(this.backgroundColor);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['backgroundColor']) {
      this.bodyBackgroundService.applyBackground(this.backgroundColor);
    }
  }

  ngOnDestroy(): void {
    // Restore original body background when component is destroyed
    this.bodyBackgroundService.restoreBackground();
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.formResetEmail?.invalid) {
      return;
    }

    const { username } = this.formResetEmail.value;
    this.submitEmail.emit(username);
  }

  clearEmailError(): void {
    this.errorDismiss.emit();
  }

  onDismissError(): void {
    this.errorDismiss.emit();
  }

  onDismissSuccess(): void {
    this.successDismiss.emit();
  }

  get logoSrc(): string {
    return this.logoType === 'white'
      ? 'assets/images/petszel-logo-vertical-white.svg'
      : 'assets/images/petszel-logo-vertical-color.svg';
  }

  get title(): string {
    return this.resetIdExists ? 'Create Password' : 'Reset Password';
  }

  get buttonText(): string {
    return this.resetIdExists ? 'Create Password' : 'Reset Password';
  }

  get instructionText(): string {
    return this.resetIdExists
      ? 'Enter account\'s verified email address to receive a password reset link.'
      : 'Enter account\'s verified email address and we will send you a password reset link.';
  }
}

